import BitcoinProfit from './btcProfit.png';
import EthereumProfit from './ethProfit.png';
import SolanaProfit from './solProfit.png';
import CardanoProfit from './adaProfit.png';

const ProfitExamples4 = () => {
  return (
    <div
      style={{
        flex: 1,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <p style={{ fontSize: 24, fontWeight: 'bold' }}>
        Big Caps Historical Profit
      </p>
      <div
        style={{
          display: 'grid',
          gridTemplateRows: 'repeat(2, 1fr)',
          gridTemplateColumns: 'repeat(2, 1fr)',
          height: '100%',
          width: '100%',
        }}
      >
        <div
          style={{
            flex: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <img src={BitcoinProfit} style={{ height: '35vh', width: '45vw' }} />
        </div>
        <div
          style={{
            flex: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <img src={EthereumProfit} style={{ height: '35vh', width: '45vw' }} />
        </div>
        <div
          style={{
            flex: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <img src={SolanaProfit} style={{ height: '35vh', width: '45vw' }} />
        </div>
        <div
          style={{
            flex: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <img src={CardanoProfit} style={{ height: '35vh', width: '45vw' }} />
        </div>
      </div>
    </div>
  );
};

export default ProfitExamples4;
